// env vars that must be set
export const buildConfig = {
  apiUrl: process.env.RAZZLE_API_URL,
  prefix: process.env.RAZZLE_PROTOCOL,
  fileHost: process.env.RAZZLE_FILE_HOST,
  publicPath: process.env.PUBLIC_PATH,
  subpath: process.env.RAZZLE_SUBPATH,
};
